

























import _ from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { ColorFamily, ColorFamilyName } from '@/models/tag/color-family'
import { ColorFamilyState, maxCheckNumber } from '@ajax/vue/components/templates/model/condition/state/color-family'

@Component
export default class SearchColor extends Vue {
  @Prop({ required: true })
  readonly state: ColorFamilyState

  get colorList(): ColorFamily[] {
    return this.state.list.list
  }

  get alreadyCheckedMaxNumber(): boolean {
    return this.state.alreadyCheckedMaxNumber
  }

  get maxNumber(): number {
    return maxCheckNumber
  }

  isSelected(name: ColorFamilyName): boolean {
    return this.state.isChecked(name)
  }

  @Emit()
  clickColor(_color: ColorFamily) {
    /* nothing */
  }

  @Emit()
  reset() {
    /* nothing */
  }
}
